import Reveal from './Reveal.jsx';
import Icon from './Icon.jsx';
import { BRANCHES } from '../data/site.js';
import { scrollToId } from '../hooks/useActiveSection.js';

export default function Branches() {
  return (
    <section id="branches" className="branches">
      <div className="container">
        <Reveal className="section-header">
          <div className="section-label">Our Locations</div>
          <h2 className="section-title">Two Branches, One Standard of Care</h2>
          <p className="section-desc">
            Visit us at either of our two conveniently located clinics for the same warm, expert
            dental care.
          </p>
        </Reveal>
        <div className="branches-grid">
          {BRANCHES.map((b, i) => (
            <Reveal className="branch-card" key={b.tag} delay={i * 90}>
              <div className="branch-tag">{b.tag}</div>
              <div className="branch-graphic">📍</div>
              <h3>{b.name}</h3>
              <div className="branch-details">
                <div className="branch-row">
                  <Icon name="pin" size={15} width={2} />
                  <span>{b.address}</span>
                </div>
                <div className="branch-row">
                  <Icon name="phone" size={15} width={2} />
                  <span>{b.phone}</span>
                </div>
                <div className="branch-row">
                  <Icon name="clock" size={15} width={2} />
                  <span>{b.hours}</span>
                </div>
              </div>
              <a
                href="#contact"
                className="btn btn-primary btn-sm"
                style={{ marginTop: '1.5rem' }}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId('contact');
                }}
              >
                Get In Touch
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
